import { toast } from "react-toastify";

export const handleDateValidation = (minDate: string, maxDate: string) => {
    const parsedMinDate = new Date(minDate);
    const parsedMaxDate = new Date(maxDate);
    const currentDate = new Date();
    console.log('minDate',minDate);
    console.log('maxDate',maxDate);
    
    console.log('parsedMinDate',parsedMinDate);
    console.log('parsedMaxDate',parsedMaxDate);
  
    // Verificar que las fechas sean válidas
    if (parsedMinDate > parsedMaxDate) {
      toast.error("La fecha mínima no puede ser mayor que la fecha máxima");
      return false;
    }
  
    // Verificar rango permitido
    if (parsedMinDate < new Date("2025-01-01") || parsedMaxDate > new Date(currentDate.setFullYear(currentDate.getFullYear() + 50))) {
      toast.error("Las fechas deben estar entre el 1 de enero de 2025 y 50 años a partir de hoy");
      return false;
    }
  
    return true;
  };
  export const handleAmountValidation = (minAmount?: { value: string } | number, maxAmount?: { value: string } | number) => {
    // Extraer y convertir los valores si están definidos
  const parsedMinAmount =
  typeof minAmount === "object" && minAmount?.value ? parseFloat(minAmount.value) :
  typeof minAmount === "number" ? minAmount : 
  null;

const parsedMaxAmount =
  typeof maxAmount === "object" && maxAmount?.value ? parseFloat(maxAmount.value) :
  typeof maxAmount === "number" ? maxAmount : 
  null;

console.log("parsedMinAmount", parsedMinAmount);
console.log("parsedMaxAmount", parsedMaxAmount);

// Validar que los valores sean números (si están definidos)
if ((parsedMinAmount !== null && isNaN(parsedMinAmount)) || (parsedMaxAmount !== null && isNaN(parsedMaxAmount))) {
  toast.error("Los valores de cantidad deben ser números válidos");
  return false;
}

// Validar que las cantidades no sean negativas (si están definidas)
if ((parsedMinAmount !== null && parsedMinAmount < 0) || (parsedMaxAmount !== null && parsedMaxAmount < 0)) {
  toast.error("Los valores de cantidad no pueden ser negativos");
  return false;
}

// Validar que minAmount no sea mayor que maxAmount (si ambos están definidos)
if (parsedMinAmount !== null && parsedMaxAmount !== null && parsedMinAmount > parsedMaxAmount) {
  toast.error("El valor mínimo no puede ser mayor que el valor máximo");
  return false;
}

// Si pasa todas las validaciones
return true;
  };
  
  
export const validateCompanyNIF = (nif: string): boolean => {
    const nifRegex = /^[A-Z]\d{7}[A-Z0-9]$/; // Formato general: Letra + 7 dígitos + dígito/letra de control.
    if (!nifRegex.test(nif)) {
      return false; // No cumple con el formato básico.
    }
  
    const letter = nif[0]; // Primera letra.
    const digits = nif.slice(1, 8); // 7 dígitos numéricos.
    const controlChar = nif[8].toUpperCase(); // Dígito o letra de control.
  
    // Cálculo del dígito de control.
    const evenSum = digits
      .split("")
      .filter((_, index) => index % 2 === 1) // Suma los dígitos en posiciones pares (0 indexado).
      .reduce((acc, num) => acc + parseInt(num), 0);
  
    const oddSum = digits
      .split("")
      .filter((_, index) => index % 2 === 0) // Duplicar dígitos en posiciones impares (0 indexado).
      .map((num) => (parseInt(num) * 2).toString())
      .reduce((acc, doubled) => {
        // Suma de los dígitos individuales.
        return (
          acc +
          doubled
            .split("")
            .reduce((subAcc, digit) => subAcc + parseInt(digit), 0)
        );
      }, 0);
  
    const totalSum = evenSum + oddSum;
    const calculatedControlDigit = (10 - (totalSum % 10)) % 10;
  
    // Si es numérico, compara el dígito; si es letra, convierte y compara.
    if (/[A-J]/.test(controlChar)) {
      const validLetter = "JABCDEFGHI"[calculatedControlDigit];
      return controlChar === validLetter;
    }
  
    return parseInt(controlChar) === calculatedControlDigit;
  };

  